import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { myOptions } from "src/components/users/UserForm";

export const fields: FilterFieldConfig[] = [
    { key: "startDate", label: "From Date", type: "range", default: "", inputType: "date" },
    { key: "endDate", label: "To Date", type: "range", default: "", inputType: "date" },
    { key: "requesterId", label: "Requester", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…", isMulti: false },
    { key: "department", label: "Department", type: "select", default: "", options: [
        { value: "", label: "Select" },
        ...Object.entries(myOptions.department).flatMap(([group, values]) =>
            (values as string[]).map(value => ({ value, label: `${group} - ${value}` }))
        ),
    ] },
    { key: "projectId", label: "Project", type: "asyncSelect", default: "", fileName: "common/searchProject.php", placeholder: "Search project…", isMulti: false },
    { key: "hotelName", label: "Hotel Name", type: "text", default: "" },
    { key: "hotelAddress", label: "Hotel Address", type: "text", default: "" },
    { key: "notes", label: "Notes", type: "text", default: "" },
    { key: "status", label: "Status", type: "select", default: "", options: [
        { value: "", label: "Select" },
        { value: "Submitted", label: "Submitted" },
        { value: "Re-Submitted", label: "Re-Submitted" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
    ] },
    { key: "approverId", label: "Approver", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…", isMulti: false },
    { key: "paid", label: "Paid", type: "select", default: "no", options: [
        { value: "no", label: "No" },
        { value: "yes", label: "Yes" },
        { value: "all", label: "All" },
    ] },
    { key: "notifiedBy", label: "Notified By", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…", isMulti: false },
    { key: "notifiedAt", label: "Notified At", type: "range", default: "", inputType: "date" },
    { key: "approvalTime", label: "Decision Time", type: "range", default: "", inputType: "date" },
    { key: "approverNotes", label: "Approver Notes", type: "text", default: "" },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "creatorId", label: "Creator", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…", isMulti: false },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…", isMulti: false },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no", options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
    ] },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function PerDiemFilterForm() {
    return <FilterModal title = "Filter" width = {650} fields = {fields} />;
}
